<template>
    <div class="admin-pages" >
        <PageTitle icon="fa fa-cogs" main="System Administration"
        sub="Registrations and Settings" />
        <div class="admin-pages-tabs">
            <b-card title="Card Title" small  no-body >
                <b-tabs card>
                     
                    <b-tab active>
                        <template v-slot:title>
                            <i class="fa fa-building"></i> <strong>Company</strong>
                        </template>
                        <CompanyAdmin />
                    </b-tab>
                     <b-tab>
                        <template v-slot:title>
                            <i class="fa fa-ellipsis-h"></i> <strong>Business Unit</strong>
                        </template>
                        <BusinessUnit />
                    </b-tab>
                     <b-tab>
                        <template v-slot:title>
                            <i class="fa fa-ellipsis-h"></i> <strong>Financial Box</strong>
                        </template>
                        <FinancialBox />
                    </b-tab>
                      <b-tab>
                        <template v-slot:title>
                            <i class="fa fa-map"></i> <strong>Region Route</strong>
                        </template>
                        <RegionRoute />
                    </b-tab>
                     <b-tab>
                        <template v-slot:title>
                            <i class="fa fa-info"></i> <strong>Default Rule Property</strong>
                        </template>
                        <DefaultRulePropertie />
                    </b-tab>
                     <!--b-tab>
                        <template v-slot:title>
                            <i class="fa fa-group"></i> <strong>Grupo de Cliente/Fornecedor</strong>
                        </template>
                        <GroupEntityAdmin />
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <i class="fa fa-inbox"></i> <strong>Tipo de Estoque</strong>
                        </template>
                        <TypeStockAdmin />
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <i class="fa fa-address-book-o"></i> <strong>Funcionário</strong>
                        </template>
                        <EmployeeAdmin />
                    </b-tab>
                        <b-tab>
                        <template v-slot:title>
                            <i class="fa fa-cog"></i> <strong>Parâmetros Globais</strong>
                        </template>
                        <GlobalParameterAdmin />
                    </b-tab!-->
                    <b-tab >
                        <template v-slot:title>
                            <i class="fa fa-user"></i> <strong>Users</strong>
                        </template>
                        <UserAdmin />
                    </b-tab>
                </b-tabs>  
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import UserAdmin from './UserAdmin'
import CompanyAdmin from './CompanyAdmin'
import BusinessUnit from './BusinessUnit'
import FinancialBox from './FinancialBox'
import RegionRoute from './RegionRoute'
import DefaultRulePropertie from './DefaultRulePropertie'


export default {
    name: 'AdminPages',
    components:{PageTitle,
                UserAdmin,
                CompanyAdmin,
                BusinessUnit,
                FinancialBox,
                RegionRoute,
                DefaultRulePropertie
                //EmployeeAdmin,
                //OfficeAdmin,
                //GroupEntityAdmin,
                //TypeStockAdmin,
                //GlobalParameterAdmin
                }
}
</script>

<style>

 .admin-pages {
            font-size: 0.75rem;
            color: black;
        }

</style>
